module.exports = __webpack_public_path__ + "img/Menu-02.0a4753c3.png";